import axios from './_nestAxios'

export const self = {
  descargarPdfxId: id =>
    axios.get(`/facturaciones/descargar/${id}/pdf`, { responseType: 'blob', params: { tipoDescarga: 'self' } }),
  descargarPdfv2xId: id =>
    axios.get(`/facturaciones/descargar/${id}/pdf`, {
      responseType: 'blob',
      params: { tipoDescarga: 'self', vDescarga: '2' }
    })
}

export const verificarParaBaja = params => axios.post('/facturaciones/verificar-para-baja', {}, { params })

export const regularizarAsientoxId = id => axios.post(`/facturaciones/${id}/regularizar-asiento`)

export const regularizarxCompaniaxSede = () => axios.post('/facturaciones/regularizar-todo')

export const validarSegundaImpresionxId = id => axios.post(`/facturaciones/${id}/validar-segunda-impresion`)

export const actualizarFechasMasivo = data => axios.post('/facturaciones/actualizar-fechas-masivo', data)

export const nuevoErrorNotifyAkdemic = data => axios.post('/facturaciones/error-notify-akdemic', data)

export const validarExistenciaDeNumeroAnterior = data =>
  axios.get('/facturaciones/verificar-numero-anterior', { params: data })

export const obtenerInfoAnulacion = () => axios.get(`/facturaciones/info-anulacion`)

export const obtenerxIdAsInfoNota = id => axios.get(`/facturaciones/${id}`, { params: { tipoConsulta: 'info-nota' } })
export const obtenerxIdAsInfoBaja = (id, anioDocumento) =>
  axios.get(`/facturaciones/${id}`, { params: { tipoConsulta: 'info-baja', anioDocumento: anioDocumento } })
export const obtenerxIdAsInfoSinEntrega = id =>
  axios.get(`/facturaciones/${id}`, { params: { tipoConsulta: 'info-sin-entrega' } })
export const obtenerxIdAsEdicion = id => axios.get(`/facturaciones/${id}`)
export const obtenerxIdAsAnular = ({ id, flagAnular }) => axios.get(`/facturaciones/${id}`, { params: { flagAnular } })
export const obtenerxIdHistorialAsEdicion = id => axios.get(`/facturaciones/historial/${id}`)
export const obtenerSinEntregaxIdSocioAsSelect = (idSocio, flagSoloCompletas) =>
  axios.get('/facturaciones/sin-entrega', {
    params: { tipoConsulta: 'select', idSocio: idSocio, soloCompletas: flagSoloCompletas }
  })
export const obtenerAnticiposxSocio = idSocio => axios.get('/facturaciones/anticipos', { params: { idSocio } })

export const modficaFechas = () => axios.post('/facturaciones/modificar-fechas')

export const nuevaFacturacion = data => axios.post('/facturaciones', data)

export const actualizarFacturacionxId = (id, data) => axios.put(`/facturaciones/${id}`, data)

export const anularFacturacionxId = (id, data, flagAnular) => axios.put(`/facturaciones/${id}`, { ...data, flagAnular })

export const actualizarFechaxId = (id, data) => axios.put(`/facturaciones/${id}/editar-fecha`, data)

export const actualizarComentariosxId = (id, data) => axios.put(`/facturaciones/${id}/editar-comentarios`, data)

export const eliminarxId = id => axios.delete(`/facturaciones/${id}`)

export const descargarPdfA4xId = id =>
  axios.get(`/facturaciones/descargar/${id}/pdf`, { responseType: 'blob', params: { tipoDescarga: 'A4' } })

export const descargarPdfTicketxId = id =>
  axios.get(`/facturaciones/descargar/${id}/pdf`, { responseType: 'blob', params: { tipoDescarga: 'ticket' } })

export const enviarCorreoxId = id => axios.post(`/facturaciones/${id}/enviar-correo`)

export const desvincularAnticiposxId = id => axios.post(`/facturaciones/${id}/desvincular-anticipos`)

export const imprimirPdfTicketCobranzas = id =>
  axios.get(`facturaciones/descargar/cobranzas/${id}/pdf`, { responseType: 'blob' })

export const descargarReporteVentas = params => axios.get('/kardex/descargar/ventas', { responseType: 'blob', params })

export const descargarReporteVentasRep = params =>
  axios.get('/facturaciones/descargar/ventasrep', { responseType: 'blob', params })

export const descargarReporteVentasRepResumen = data =>
  axios.get('/facturaciones/descargar/ventasrep', {
    params: { ...data, tipoConsulta: 'resumen' },
    responseType: 'blob'
  })

export const descargarReporteVentasRepMinimo = data =>
  axios.get('/facturaciones/descargar/ventasrep', {
    params: { ...data, tipoConsulta: 'minimo' },
    responseType: 'blob'
  })

export const descargarReporteUtilidad = data =>
  axios.get('/facturaciones/descargar/utilidad', { responseType: 'blob', params: data })

export const descargarFormatoCruceVentasKardex = data =>
  axios.get('/facturaciones/descargar/cruce-ventas-kardex', { responseType: 'blob', params: data })

export const descargarReporteEntradasSalidas = data =>
  axios.get('/facturaciones/descargar/entradas-salidas', { responseType: 'blob', params: data })

export const verDetallesConsultaVentas = (_id, anio) =>
  axios.get(`/facturaciones/verDetalles/ConsultaVentas/${_id}`, {
    params: { anio }
  })

export const obtenerHistorialxIdFromFacturacion = id => axios.get(`/facturaciones/historialSocio/${id}`)

export const obtenerResumenMovimientoxIdTurnoAsInfoVista = params =>
  axios.get('/facturaciones/resumen-x-turno', { params: params })
